var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      ref: "entrtSider",
      staticClass: "entry-sider",
      class: {
        "entry-sider--active": _vm.visible,
        "entry-sider--unfold": _vm.unfold,
      },
    },
    [
      _c("div", { staticClass: "entry-sider__content" }, [
        _c("div", { staticClass: "entry-sider-panel" }, [
          _c(
            "section",
            {
              staticClass: "entry-sider-panel__hd",
              on: {
                mouseenter: _vm.allAppMouseEnter,
                mouseout: _vm.allAppMouseOut,
              },
            },
            [
              _c(
                "a",
                {
                  staticClass: "entry-sider__menu",
                  on: { click: _vm.handleSiderPaneToggle },
                },
                [
                  _c(
                    "div",
                    { staticClass: "entry-sider__menu__hd" },
                    [
                      _c("a-icon", {
                        attrs: {
                          type: !_vm.unfold ? "menu-fold" : "menu-unfold",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "entry-sider__menu__bd" }, [
                    _vm._v(_vm._s(_vm.i18nRender("layouts.allapplication"))),
                  ]),
                ]
              ),
            ]
          ),
          _c("section", { staticClass: "entry-sider-panel__bd" }, [
            _c(
              "div",
              {
                staticClass: "entry-slider-tabs",
                on: { scroll: _vm.handleScroll },
              },
              [
                _vm._l(_vm.menus, function (menu) {
                  return [
                    _c(
                      "entry-sider-item",
                      {
                        key: menu.key,
                        attrs: {
                          menu: menu,
                          visible: _vm.visible || _vm.unfold,
                          currentLang: _vm.currentLang,
                          scrollTop: _vm.scrollTop,
                          activeKey: (_vm.menusInfo && _vm.menusInfo.key) || "",
                        },
                        on: {
                          mousemove: _vm.handleMenusMousemove,
                          mouseout: _vm.handleClearTimeout,
                          click: _vm.handleMenusClick,
                          menuchange: _vm.handleMenuChange,
                          pushpin: _vm.handlePushpin,
                        },
                      },
                      [
                        menu.childMenus.filter((item) => item.pushpin).length
                          ? _c("div", {
                              staticClass: "entry-sider__menu__arrow-down",
                            })
                          : _c("div", {
                              staticClass: "entry-sider__menu__arrow-right",
                            }),
                      ]
                    ),
                  ]
                }),
              ],
              2
            ),
          ]),
          _c("section", { staticClass: "entry-sider-panel__ft" }, [
            _c(
              "div",
              { staticClass: "entry-slider-tabs" },
              [
                _c("entry-sider-item", {
                  attrs: {
                    menu: {
                      icon: "thunderbolt",
                      tab: _vm.i18nRender("layouts.commonmenu"),
                    },
                    visible: _vm.visible,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleMenusChange("__HISTORY__")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm.menusInfo
          ? _c("div", { staticClass: "entry-sider-info" }, [
              _c(
                "section",
                { staticClass: "entry-sider-info__hd" },
                [
                  _c("icon-font", {
                    staticClass: "entry-sider-info__close",
                    attrs: { type: "gb-icon-guanbi" },
                    on: { click: _vm.close },
                  }),
                  _c("a-input-search", {
                    staticStyle: { width: "75%" },
                    attrs: {
                      size: "large",
                      placeholder: _vm.i18nRender("layouts.search.placeholder"),
                    },
                    model: {
                      value: _vm.keyword,
                      callback: function ($$v) {
                        _vm.keyword = $$v
                      },
                      expression: "keyword",
                    },
                  }),
                  _c("div", { staticClass: "entry-sider-info__histroy" }, [
                    _c(
                      "div",
                      { staticClass: "entry-sider-info__histroy__label" },
                      [_vm._v(_vm._s(_vm.i18nRender("layouts.history")) + "：")]
                    ),
                    _vm.panesHistory.length
                      ? _c(
                          "div",
                          { staticClass: "entry-sider-info__histroy__value" },
                          _vm._l(_vm.panesHistory, function (pane) {
                            return _c(
                              "a",
                              {
                                key: pane.key,
                                staticClass: "entry-sider-info__histroy__item",
                                attrs: { href: "javascript:;" },
                                on: {
                                  click: (key) =>
                                    _vm.handleMenuChange(pane.key, {
                                      statisticsType: 3,
                                      searchKey: "",
                                    }),
                                },
                              },
                              [_vm._v(_vm._s(_vm._f("menuLocalName")(pane)))]
                            )
                          }),
                          0
                        )
                      : _c(
                          "div",
                          { staticClass: "entry-sider-info__histroy__value" },
                          [
                            _c("span", { staticStyle: { color: "#999" } }, [
                              _vm._v(
                                _vm._s(_vm.i18nRender("layouts.text.undefined"))
                              ),
                            ]),
                          ]
                        ),
                  ]),
                ],
                1
              ),
              _vm.keyword
                ? _c(
                    "section",
                    { staticClass: "entry-sider-info__bd" },
                    [
                      _c("entry-menus-search", {
                        attrs: {
                          menus: _vm.menus,
                          keyword: _vm.keyword,
                          currentLang: _vm.currentLang,
                        },
                        on: {
                          click: (key) =>
                            _vm.handleMenuChange(key, {
                              statisticsType: 1,
                              searchKey: _vm.keyword,
                            }),
                        },
                      }),
                    ],
                    1
                  )
                : _c(
                    "section",
                    { staticClass: "entry-sider-info__bd" },
                    [
                      _c("entry-menus-item", {
                        attrs: {
                          "tap-position": "top",
                          menu: _vm.menusInfo,
                          currentLang: _vm.currentLang,
                        },
                        on: {
                          click: (key) =>
                            _vm.handleMenuChange(key, {
                              statisticsType: 2,
                              searchKey: "",
                            }),
                          pushpin: _vm.handlePushpin,
                        },
                      }),
                    ],
                    1
                  ),
            ])
          : _vm._e(),
      ]),
      _c("div", {
        staticClass: "entry-sider__mask",
        class: { "entry-sider__mask--active": _vm.visible },
        on: { mouseover: _vm.close },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }